export default __webpack_public_path__ + "img/TourStep2-a90e97bd3893bc5f3f062a6a0848ea6d.png";